var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.isLikingClasses,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleLike(_vm.entity_id)}}},[(_vm.signed_in)?_c('span',{staticClass:"icon-thumbs-up"}):_vm._e(),(_vm.signed_in)?_c('span',[_vm._v(_vm._s(_vm.likeText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }